import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "d-flex flex-column gap-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.guidException, (item, index) => {
      return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(_ctx.getException(item) + "; "), 1))
    }), 128))
  ]))
}